import { useQuery } from '@tanstack/react-query';
import { fetchCustomersDropdown } from '../api/customersApi';

// Separate cache key from the paged ['customers', filter] list so opening a
// form doesn't pollute or invalidate the table cache.
export default function useCustomersDropdown() {
    return useQuery({
        queryKey: ['customers', 'dropdown'],
        queryFn: fetchCustomersDropdown,
    });
}
